import React, { Component } from "react";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";
import { StyledViewAllTemplatesInfiniteScrollGrid } from "../styled/home/stylesHome";
import { Flex, Text } from "@chakra-ui/react";

class TLDRInfiniteScroll extends Component {
  render() {
    const {
      childrens,
      className,
      loaded,
      hasMore,
      loadMoreData,
      scrollableTarget,
      wrapChildrenInCustomGrid,
      templatesPerRow,
      showLoading
    } = this.props;
    return (
      <InfiniteScroll
        //adding spining loader makes double scrollers
        loader={
          !showLoading &&
          <Flex align="center" justify="center">
            <Text fontSize={"sm"} fontWeight="bold" color="brand.primary">
              {"Loading"}
            </Text>
          </Flex>
        }
        className={className}
        dataLength={childrens.length}
        next={loadMoreData}
        hasMore={hasMore}
        scrollableTarget={scrollableTarget}
      >
        {wrapChildrenInCustomGrid ? (
          <StyledViewAllTemplatesInfiniteScrollGrid
            templatesPerRow={templatesPerRow}
          >
            {childrens}
          </StyledViewAllTemplatesInfiniteScrollGrid>
        ) : (
          <>{childrens}</>
        )}
      </InfiniteScroll>
    );
  }
}

TLDRInfiniteScroll.propTypes = {
  childrens: PropTypes.array.isRequired,
  loadMoreData: PropTypes.func.isRequired,
};

TLDRInfiniteScroll.defaultProps = {
  className: "",
  hasMore: false,
  loaded: false,
  wrapChildrenInCustomGrid: false,
  templatesPerRow: 2,
};

export default TLDRInfiniteScroll;
